export enum IdentityType {
	Passport,
	IdentityDocument,
}
